// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2cbKg","content":"LayoutSettings_content__p9QsY"};